module.exports = __webpack_public_path__ + "static/zaratan-1a5706847d390c55d77dbd2b81ab7ea0.png";